import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './plugins'
import vuetify from './plugins/vuetify'
import { sync } from 'vuex-router-sync'
import i18n from './i18n'
import api from './components/backend/backend-api'
import Vuelidate from 'vuelidate'
import {USER_REQUEST} from "./store/actions/user";
import mixins from "./utils/mixins"
sync(store, router)
api.configureProxy()

Vue.config.productionTip = false






new Vue({
  router,
  store,
  i18n: i18n,
  vuetify,
  created() {
    this.$store.dispatch(USER_REQUEST)



  },
  render: h => h(App)
}).$mount('#app')

Vue.use(Vuelidate)

Vue.use(require('vue-moment'));


